import {inject, injectable} from "inversify";
import type {IUser} from "data/stores/user/user.store";
import type {IApiResponse, IHttpClientService} from "data/services/http";
import type {AxiosResponse} from "axios";
import {Bindings} from "data/constants/bindings";
import {PlayedGames} from "data/enums";

export interface IRegistrationPayload {
	username: string;
	email: string;
	password: string;
}

export interface IUpdateUserPayload {
	email?: string | null;
	firstName?: string | null;
	lastName?: string | null;
	password?: string | null;
	username?: string | null;
	favTeam?: string | null;
	isNotificationsEnabled?: boolean | null;
	optIn?: boolean | null;
}

export interface IUsername {
	username: string;
}

export interface IUserGamePayload {
	game: PlayedGames;
}

export type TUserResponse = IApiResponse<{user: IUser}>;
export type TGeoResponse = IApiResponse<{isAllowed: boolean}>;

export interface IUserApiProvider {
	register: (params: IRegistrationPayload) => Promise<AxiosResponse<TUserResponse>>;
	update: (params: IUpdateUserPayload) => Promise<AxiosResponse<TUserResponse>>;
	user: () => Promise<AxiosResponse<TUserResponse>>;
	user_games: (params: IUserGamePayload) => Promise<AxiosResponse<TUserResponse>>;
	checkUsername: (params: IUsername) => Promise<AxiosResponse>;
	deactivateAccount: () => Promise<AxiosResponse>;
	check_user_geo: () => Promise<AxiosResponse<TGeoResponse>>;
}

@injectable()
export class UserApiProvider implements IUserApiProvider {
	constructor(@inject(Bindings.ApiHTTPClient) private _http: IHttpClientService) {}

	checkUsername = (params: IUsername) => this._http.post<void>("user/check_username", params);

	deactivateAccount = () => this._http.post<void>("user/deactivate_account");

	register = (params: IRegistrationPayload) =>
		this._http.post<TUserResponse>("user/register", params);

	update = (params: IUpdateUserPayload) => this._http.post<TUserResponse>("user/update", params);

	user = () => this._http.get<TUserResponse>("user");

	user_games = (params: IUserGamePayload) =>
		this._http.post<TUserResponse>(`user/register_for_game`, params);

	check_user_geo = () => this._http.get<TGeoResponse>("geo/check_geo");
}
